import { Step } from "../../steps/state";

export type ProjectUploadState = {
    status: "ok" | "preparing" | "saving" | "sharing";
};

export type ProjectFile = {
    // file: File,
    step?: Step,
    bucket?: {
        type: string,
        name: string,
        uploadUrl: string,
        key: string
    }
}

export const initState: ProjectUploadState = {
    status: "ok",
};
